import React from "react";
import { Mail, MapPin } from "lucide-react";
import { useLang } from "../context/LanguageContext";
import { useReveal } from "./Home";
import ContactForm from "../components/ContactForm";
import Seo from "../components/Seo";

const Contact = () => {
  const ref = useReveal();
  const { t } = useLang();

  return (
    <div ref={ref}>
      <Seo title={t.seo.contact.title} description={t.seo.contact.description} />
      <section className="relative overflow-hidden bg-[#0f1a10] pb-20 pt-40">
        <div className="absolute inset-0 opacity-20">
          <img src={t.hero.slides[0]} alt="" className="h-full w-full object-cover grayscale" />
        </div>
        <div className="relative mx-auto max-w-[1200px] px-6">
          <span className="text-sm font-semibold uppercase tracking-widest text-[#F26522]">{t.contact.title}</span>
          <h1 className="mt-3 max-w-3xl text-4xl font-extrabold leading-tight text-white lg:text-5xl">{t.contact.pageTitle}</h1>
          <p className="mt-5 max-w-2xl text-lg leading-relaxed text-neutral-300">{t.contact.intro}</p>
        </div>
      </section>

      <section className="mx-auto max-w-[1200px] px-6 py-20 lg:py-24">
        <div className="grid gap-12 lg:grid-cols-5">
          <div className="reveal lg:col-span-2">
            <h2 className="text-2xl font-bold text-neutral-900">{t.contact.infoTitle}</h2>
            <p className="mt-3 text-[15px] leading-relaxed text-neutral-600">{t.contact.infoText}</p>

            <div className="mt-8 grid gap-5 sm:grid-cols-2">
              {t.contact.offices.map((o) => (
                <div key={o.city} className="rounded-xl border border-neutral-100 bg-white p-5 shadow-sm">
                  <div className="flex items-center gap-2.5">
                    <div className="flex h-9 w-9 items-center justify-center rounded-lg bg-[#F26522]/10 text-[#F26522]">
                      <MapPin className="h-4.5 w-4.5" />
                    </div>
                    <span className="text-base font-bold text-neutral-900">{o.city}</span>
                  </div>
                  <div className="mt-3 space-y-0.5 text-[15px] leading-relaxed text-neutral-600">
                    {o.lines.map((line) => (
                      <div key={line}>{line}</div>
                    ))}
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-6 flex items-center gap-3 rounded-xl bg-neutral-50 p-5">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-lg bg-[#F26522]/10 text-[#F26522]">
                <Mail className="h-5 w-5" />
              </div>
              <div>
                <div className="text-xs font-semibold uppercase tracking-wide text-neutral-500">{t.contact.labels.email}</div>
                <a href={`mailto:${t.contact.email}`} className="mt-0.5 block text-[15px] font-medium text-neutral-900 transition-colors hover:text-[#F26522]">
                  {t.contact.email}
                </a>
              </div>
            </div>
          </div>
          <div className="reveal rounded-xl border border-neutral-100 bg-white p-8 shadow-sm lg:col-span-3">
            <ContactForm />
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;
